import apiService from '@/services/apiService';

const actions = {
  getAllPINSettingWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('cx/claim-setting/pin/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPINSetting({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`cx/claim-setting/pin/find-by-id/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getClaimUsers({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('cx/claim-setting/users?setting_type=pin_setting')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  createPINSetting({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('cx/claim-setting/pin', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePINSetting({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/claim-setting/pin/update/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deletePINSetting({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`cx/claim-setting/pin/delete/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
};

export default actions;